import React from 'react';
import VisitorInfoForm from './form/visitorInfoForm';

const VisitorInfo = () => {
  return <VisitorInfoForm />;
};

export default VisitorInfo;
